module.exports = __webpack_public_path__ + "img/person-frame.3ed0b60b.webp";